import(/* webpackMode: "eager" */ "/vercel/path0/app/(info)/terms/page.tsx");
